module.exports = __webpack_public_path__ + "static/media/5.92d3c90e.jpg";